var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlogIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.237,
    height: 16.4,
    viewBox: "0 0 14.237 16.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fdfffc;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(1158 14784)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5221",
    "data-name": "Rectangle 5221",
    className: "cls-1",
    width: 1.262,
    height: 16.4,
    transform: "translate(-1145.024 -14784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_10",
    "data-name": "Subtraction 10",
    className: "cls-1",
    d: "M12.435,16.4H0V0H12.435V16.4h0ZM3.064,10.092v.522H9.371v-.522Zm0-1.622v.522H9.371V8.47ZM6.308,2.884A1.622,1.622,0,1,0,7.93,4.505,1.624,1.624,0,0,0,6.308,2.884Z",
    transform: "translate(-1158 -14784)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogIcon);
export default __webpack_public_path__ + "static/media/blog-icon.13d715159b4b92d9d02f6398c0ed6631.svg";
export { ForwardRef as ReactComponent };